var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopNavTextBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 28 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    d: "M.722 24.905a.722.722 0 01-.695-.535.738.738 0 01.325-.824 9.068 9.068 0 003.816-4.656C1.513 16.825 0 13.973 0 10.988 0 9.48.375 8.02 1.11 6.648c.705-1.31 1.708-2.486 2.981-3.49C6.674 1.123 10.097 0 13.731 0c3.636 0 7.059 1.122 9.642 3.159 1.273 1.003 2.276 2.18 2.98 3.488.736 1.374 1.11 2.834 1.11 4.34a9.103 9.103 0 01-1.11 4.34c-.704 1.31-1.707 2.487-2.98 3.49-2.583 2.037-6.006 3.158-9.641 3.158-1.495 0-2.958-.188-4.358-.563a29.583 29.583 0 01-3.165 1.859c-2.154 1.085-3.996 1.634-5.487 1.634zm13.005-23.44c-6.773 0-12.282 4.271-12.282 9.523 0 2.66 1.45 5.219 3.983 7.023a.74.74 0 01.284.787c-.167.64-.745 2.39-2.28 4.084 1.883-.669 3.906-1.827 5.4-2.87a.72.72 0 01.61-.102c1.368.399 2.813.6 4.29.6 6.773 0 12.282-4.271 12.282-9.522 0-5.252-5.513-9.523-12.287-9.523z"
  })));
}

export default SvgTopNavTextBack;